module.exports = __webpack_public_path__ + "media/rise4.af3c5797.mp4";